export enum ReportHeaderType {
  TABULAR = 'TABULAR',
  DROPDOWN = 'DROPDOWN'
}

export enum ReportRole {
  BUYER = 'BUYER',
  SELLER = 'SELLER'
}
